import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { Horse_show } from '../models/horse_show';
import { Horse_show_entry } from '../models/horse_show_entry';
import { Submitted_entries_receipt } from '../models/submitted_entries_receipt';
import { Submitted_entries_cheque_receipt } from '../models/submitted_entries_cheque_receipt';
import {AccountHorseShowEntriesView} from '../models/account_horse_show_entries_view';
import {AccountEntryView} from '../models/account_entry_view';

@Injectable({
  providedIn: 'root'
})
export class CheckoutService {
//Checking Out Of the submitting an entry process

  private horse_show$:Subject<AccountHorseShowEntriesView> = new BehaviorSubject<AccountHorseShowEntriesView>(new AccountHorseShowEntriesView({}));
  private horse_show_entry_list$:Subject<AccountEntryView[]> = new BehaviorSubject<AccountEntryView[]>([]);
  private submitted_entries_receipt$:Subject<Submitted_entries_receipt> = new BehaviorSubject<Submitted_entries_receipt>(new Submitted_entries_receipt({}));
  private submitted_entries_cheque_receipt$:Subject<Submitted_entries_cheque_receipt> = new BehaviorSubject<Submitted_entries_cheque_receipt>(new Submitted_entries_cheque_receipt({}));

  public setHorse_show(horse_show: AccountHorseShowEntriesView){
  	this.horse_show$.next(horse_show);
  }

  public setHorse_show_entry_list(horse_show_entry_list: AccountEntryView[]){
  	this.horse_show_entry_list$.next(horse_show_entry_list);
  }

  public setSubmitted_entries_receipt(submitted_entries_receipt: Submitted_entries_receipt){
    this.submitted_entries_receipt$.next(submitted_entries_receipt);
  }

  public setSubmitted_entries_cheque_receipt(submitted_entries_cheque_receipt: Submitted_entries_cheque_receipt){
    this.submitted_entries_cheque_receipt$.next(submitted_entries_cheque_receipt);
  }

  getHorse_show(): Observable<AccountHorseShowEntriesView> {
    return this.horse_show$.asObservable();
  }

  getHorse_show_entry_list(): Observable<AccountEntryView[]> {
    return this.horse_show_entry_list$.asObservable();
  }

  getSubmitted_entries_receipt(): Observable<Submitted_entries_receipt> {
    return this.submitted_entries_receipt$.asObservable();
  }

  getSubmitted_entries_cheque_receipt(): Observable<Submitted_entries_cheque_receipt> {
    return this.submitted_entries_cheque_receipt$.asObservable();
  }


}
